@if (isHandset()) {
<lib-vertical-menu-mobile-nav [navigationItems]="navigationItems"></lib-vertical-menu-mobile-nav>
}
@else {
<lib-vertical-nav [navigationItems]="navigationItems"></lib-vertical-nav>
}